<mat-card [ngClass]="{ slettet: slettet }">
  <mat-card-content>
    <a
      mat-card-image
      class="mat-card-image"
      href="#"
      target="_blank"
      [href]="formGroup.controls.url.value"
      [style.background-image]="'url(' + formGroup.controls.url.value + ')'"
      >
    </a>
  </mat-card-content>
  <mat-card-actions fxLayoutAlign="end center">
    <span>{{ formGroup.controls.filNavn.value }}</span>
    @if (formGroup.controls.noteBilagId.value === 0) {
      <button
        mat-icon-button
        type="button"
        color="basic"
        matTooltip="Roter billede"
        matTooltipPosition="above"
        (click)="onRoterClick()"
        aria-label="Roter billede til højre"
        >
        <mat-icon svgIcon="rotate-right"></mat-icon>
      </button>
    }
    @if (!slettet) {
      <button
        mat-icon-button
        type="button"
        color="basic"
        matTooltip="Slet fil"
        matTooltipPosition="above"
        (click)="slettet = true"
        aria-label="Slet fil"
        >
        <mat-icon svgIcon="trash-can-outline"></mat-icon>
      </button>
    }
    @if (slettet) {
      <button
        mat-icon-button
        type="button"
        color="basic"
        matTooltip="Fortryd sletning"
        matTooltipPosition="above"
        (click)="slettet = false"
        aria-label="Fortryd sletning"
        >
        <mat-icon svgIcon="plus"></mat-icon>
      </button>
    }
  </mat-card-actions>
</mat-card>
